import * as React from "react";
const SvgPlus = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" strokeWidth={2} viewBox="0 0 24 24" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5 12h14m-7-7v14" /></svg>;
export default SvgPlus;